import { useEffect, useState, useCallback } from 'react';

import ColaboradorService from '@services/ColaboradorService';

const useColaboradores = (processo) => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);

        if (!processo)
            return;

        ColaboradorService.filtrar(processo, [{ field: 'processo', value: processo }, { field: 'size', value: 9999950 }])
            .then(res => setData(res.data.content.map(c => ({ label: `${c.nome} ${c.sobrenome}`, value: c.id }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, [processo]);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useColaboradores;